import MCPwd from "./MCPwd";

export default MCPwd;